import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Skeleton from "@material-ui/lab/Skeleton";

const useStyles = makeStyles((theme: any) => ({
  lineDuration: {
    position: "absolute",
    width: `calc(100% - ${theme.spacing(2)}px)`,
    marginTop: 25,
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    paddingLeft: theme.spacing(0.25),
    paddingRight: theme.spacing(0.25),
  },
}));

export default function LineDurationPlaceHolder() {
  const classes = useStyles();
  return <Skeleton className={classes.lineDuration} />;
}
